export const SignIn = {
  traveler: {
    label: "traveler",
    link: "https://trav.navairra.com"
  },
  operator: {
    label: "operator",
    link: "https://trav.navairra.com"
  },
  broker: {
    label: "broker",
    link: "https://trav.navairra.com"
  }
} as const;

export type SignInType = (typeof SignIn)[keyof typeof SignIn];
